<template>
    <div class="p-t-md p-b-lg">
        <div class="block is-inline-flex">
            <p class="is-size-2 has-text-weight-bold">
                Apps
            </p>
        </div>
        <div class="block" v-if="isRole('superadmin')">
            <b-button v-if="!isShowArchive" @click="isShowArchive=true">
                Show archived
            </b-button>
            <b-button v-else @click="isShowArchive=false">
                Hide archived
            </b-button>
        </div>
        <div class="block box">
            <b-table
            :data="apps"
            :columns="columns"
            >
                <template slot-scope="props">
                    <b-table-column>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column>
                        <b-input v-model="props.row.name"
                        v-show="editRow===props.row.id" :ref="'edit'+props.row.id" @keyup.native.enter="save(props.row)"/>
                        <a :href="props.row.referrer" v-show="editRow!==props.row.id">
                            {{props.row.name}}
                        </a>
                    </b-table-column>
                    <b-table-column>
                            <b-switch
                                @input="reportStatus(props.row)"
                                :nativeValue="props.row.report_status"
                                :value="props.row.report_status ? true : false"
                                type="is-info"
                            ></b-switch>
                    </b-table-column>
                    <b-table-column v-if="auth.roles.includes('superadmin')">
                        <div class="buttons">
                            <b-button @click="setEdit(props.row)" v-show="editRow!==props.row.id">
                                Edit
                            </b-button>
                            <b-button @click="save(props.row)" v-show="editRow===props.row.id">
                                Save
                            </b-button>
                            <b-button @click="restore(props.row)" v-if="props.row.archived_at">
                                Restore
                            </b-button>
                            <b-button @click="archive(props.row)" v-else>
                                Archive
                            </b-button>

                        </div>
                    </b-table-column>
                </template>
                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>
                                <b-icon icon="alert-decagram-outline" size="is-large"></b-icon>
                            </p>
                            <p>NO RESULTS FOUND</p>
                        </div>
                    </section>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
export default {
    data() {
        return {
            columns:[
                {
                    label:'Id',
                },
                {
                    label:'Name',
                },
                {
                    label:'Report Status'
                }
            ],
            editRow:null,
            apps:[],
            isShowArchive:false,
        }
    },
    computed:{
        auth(){
            return this.$store.state.auth
        }
    },
    watch:{
        isShowArchive(){
            this.getApps()
        }
    },
    created() {
        if(this.auth.roles.includes('superadmin')){
            this.columns.push({
                label:'Actions'
            })
        }
    },
    mounted(){
        this.getApps()
    },
    methods:{
        getApps(){
            let params = ''
            if(this.isShowArchive){
                params+=`?archive=true`
            }
            Vue.$appService.appList(params).then((response)=>{
                this.apps = response
            })
        },
        setEdit(row){
            this.editRow = row.id
            this.$refs['edit'+row.id].focus()
        },
        save(row){
            Vue.$appService.updateApp(row.id,{
                name:row.name,
                report_status:row.report_status
            }).then(()=>{
                this.$buefy.toast.open({
                    type: 'is-success',
                    message: 'App saved!'
                })
                this.editRow=null
            })
        },
        archive(row){
            Vue.$appService.updateApp(row.id,{
                name:row.name,
                is_archived:true
            }).then(()=>{
                this.$buefy.toast.open({
                    type: 'is-success',
                    message: 'App archived!'
                })
                this.getApps()
            })
        },
        restore(row){
            Vue.$appService.updateApp(row.id,{
                name:row.name,
                is_archived:false
            }).then(()=>{
                this.$buefy.toast.open({
                    type: 'is-success',
                    message: 'App restored!'
                })
                this.getApps()
            })
        },
        reportStatus(row){
            row.report_status = !row.report_status
            this.save(row);
        }
    }
}
</script>